const ProgressBar = ({ target = 0 }) => {
  return (
    <div className="mt-3 h-2 rounded-full bg-gray-100 overflow-hidden">
      <div
        className="h-full bg-red-500 rounded-full transition-all duration-500"
        style={{
          width: `${Math.min(target, 100)}%`
        }}
      />
    </div>
  )
}

export default ProgressBar
